import styled from 'styled-components';

export const ProcedureInformationText = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--text-text02);

  div {
    margin-bottom: 10px;
  }

  ul {
    list-style: disc;
    margin-left: 24px;
  }
`;

export const BtnRequest = styled.button`
  background: #5b36f2;
  border-radius: 4px;
  padding: 10px 16px;
  width: 100%;
  margin-top: 24px;
  margin-bottom: 32px;

  p {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #ffffff;
  }

  @media (min-width: 640px) {
    width: 145px;
  }

  &:hover {
    transition: background 150ms ease-in-out;
    background: #745ef6;
  }

  &:focus {
    transition: background 400ms ease-in-out;
    background: #4318cd;
  }

  &:active {
    transition: background 0ms ease-in-out;
    background-color: #4318cd;
  }
`;

export const CommonCard = styled.div`
  background-color: #fff;
  width: 100%;
  padding: 16px;
  margin: 12px 0px 16px 0px;
  border-radius: 8px;
`;

export const ProcedureInfoStyle = styled.div`
  .requirements__container {
    display: flex;
    flex-direction: column;
    padding-bottom: 8px;
    gap: 4px;
  }

  .requirements__container--question {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #161d1f;
  }

  .requirements__container--answer {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: '#1';

    a {
      &:focus {
        outline: none;
        border-radius: 4px;
        border: 1px solid #4318cd;
      }
    }
  }

  .notification {
    display: flex;
    padding: 8px 8px 0px 0;

    p {
      color: #1a055d;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
    }
  }

  // @media (min-width: 640px) {
  //   max-width: 744px;
  // }
`;
